import { useToast } from '@shared/hooks/use-toast';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { LegacyDashboardClient } from '../models/LegacyDashboardClient';
import { downloadLegacyDashboardExcel } from '../utils/exportLegacyDashboardToExcel';

export function useExportLegacyDashboard() {
  const { t } = useTranslation('legacyDashboardModule');
  const { toast } = useToast();
  const [isExporting, setIsExporting] = useState(false);

  const exportLegacyDashboard = useCallback(
    async (clients: LegacyDashboardClient[]) => {
      setIsExporting(true);
      try {
        downloadLegacyDashboardExcel(clients, t);
        toast({
          title: t('export.success.title'),
          description: t('export.success.description'),
          variant: 'default',
        });
      } catch (error) {
        const message = error instanceof Error ? error.message : String(error);
        toast({
          title: t('export.error.title'),
          description: message === 'NO_DATA' ? t('export.error.no_data') : t('export.error.unexpected'),
          variant: 'destructive',
        });
      } finally {
        setIsExporting(false);
      }
    },
    [t, toast],
  );

  return { exportLegacyDashboard, isExporting };
}
